import RecentSurveys from "@pulse/features/dashboard/RecentSurveys/RecentSurveys";
import usePulseId from "@pulse/hooks/usePulseId";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ActiveSurveysBox, CompletedSurveysBox, DraftsBox, TotalSurveysBox } from "./StatusBoxes";
import { useSelectedCustomerIdParam } from "@/features/hub/selectedCustomerContext";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";

export default function OverviewArea() {
    const { t } = useTranslation();
    const pulseId = usePulseId();
    const customerId = useSelectedCustomerIdParam();
    return (
        <div className="grid w-full grid-cols-8 gap-4">
            <ActiveSurveysBox />
            <CompletedSurveysBox />
            <DraftsBox />
            <TotalSurveysBox />
            <section className="col-span-8 flex flex-col gap-4">
                <div className="flex flex-row flex-wrap items-center justify-between gap-4 font-bold">
                    {t("dashboard.recentSurveys")}
                    <Link
                        to="/$customerId/pulse/$pulseId/surveys"
                        params={{ customerId, pulseId: String(pulseId) }}
                        className="group text-text-secondary inline-flex items-center gap-2 hover:underline text-sm"
                    >
                        {t("dashboard.viewAll")}
                        <FontAwesomeIcon
                            icon={faArrowRight}
                            className="text-compendia-greige group-hover:text-compendia-foreground size-4 transition-all duration-300 ease-out group-hover:translate-x-1"
                        />
                    </Link>
                </div>
                <RecentSurveys pulseInstanceId={pulseId} />
            </section>
        </div>
    );
}
